import React from 'react';

function SupportIcon(props) {
    return (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.25">
                <path d="M2.97897 20.2042C2.5348 20.2042 2.16647 19.8358 2.16647 19.3917V13.2167C2.1123 10.2808 3.20647 7.50749 5.24314 5.42749C7.2798 3.35833 10.0098 2.22083 12.9456 2.22083C18.9473 2.22083 23.8331 7.10666 23.8331 13.1083V19.2833C23.8331 19.7275 23.4648 20.0958 23.0206 20.0958C22.5765 20.0958 22.2081 19.7275 22.2081 19.2833V13.1083C22.2081 8.00583 18.059 3.84583 12.9456 3.84583C10.4431 3.84583 8.1248 4.80999 6.4023 6.56499C4.66897 8.33083 3.74814 10.6817 3.79147 13.195V19.3808C3.79147 19.8358 3.43397 20.2042 2.97897 20.2042Z" fill="white"/>
                <path d="M6.43484 13.4875H6.294C4.019 13.4875 2.1665 15.34 2.1665 17.615V19.6517C2.1665 21.9267 4.019 23.7792 6.294 23.7792H6.43484C8.70984 23.7792 10.5623 21.9267 10.5623 19.6517V17.615C10.5623 15.34 8.70984 13.4875 6.43484 13.4875Z" fill="white"/>
                <path d="M19.7058 13.4875H19.565C17.29 13.4875 15.4375 15.34 15.4375 17.615V19.6517C15.4375 21.9267 17.29 23.7792 19.565 23.7792H19.7058C21.9808 23.7792 23.8333 21.9267 23.8333 19.6517V17.615C23.8333 15.34 21.9808 13.4875 19.7058 13.4875Z" fill="white"/>
            </g>
        </svg>

    );
}

export default SupportIcon;
